import { useQuery } from "@tanstack/react-query";
import lensService from "../../../services/lensService";

const usePlaybook = (key: string | undefined) =>
    useQuery({
        queryKey: ["lens", "playbook", key],
        queryFn: () => lensService.fetchPlaybook(key as string),
        enabled: !!key,
        refetchInterval: (query) => (query.state.data?.generationStatus === "generating" ? 3000 : false),
    });

export default usePlaybook;
